import { useNavigation } from "@react-navigation/core";
import { Box, Button, FlatList, HStack, Text, VStack } from "native-base";

type Props = {};

export default function AfterTreatment({}: Props) {
  const navigation = useNavigation();

  const data = [
    {
      id: "1",
      title: "Cirurgia reparadora",
      description:
        "Cirurgia para simetrização das mamas e reconstrução do complexo areolo papilar (mamilo)",
      infoId: 43,
    },
  ];

  const handleClickMoreInfo = (infoId: number) => {
    navigation.navigate("InfoPage", { infoId });
  };

  return (
    <Box flex={1} bgColor="white" p="8">
      <VStack space={8} w="100%">
        <Text
          fontSize="2xl"
          fontWeight="bold"
          textAlign="center"
          color="#f4545c"
        >
          Depois do Tratamento você tem acesso aos seguintes direitos
        </Text>
        <FlatList
          w="100%"
          h="80%"
          data={data}
          renderItem={({ item }) => (
            <Box pl={["0", "4"]} pr={["0", "5"]} pb="8">
              <HStack
                space={[2, 3]}
                justifyContent="space-between"
                alignItems="center"
              >
                <VStack space={2}>
                  <Text color="#e8af9d" bold fontSize="md">
                    {item.title}
                  </Text>
                  <Text
                    color="coolGray.600"
                    _dark={{
                      color: "warmGray.200",
                    }}
                    fontSize="sm"
                    maxW="80%"
                  >
                    {item.description}
                  </Text>
                </VStack>
                <Button
                  bg="#f4545c"
                  h="16"
                  onPress={() => handleClickMoreInfo(item.infoId)}
                >
                  + Info
                </Button>
              </HStack>
            </Box>
          )}
          keyExtractor={(item) => item.id}
        />
      </VStack>
    </Box>
  );
}
